const columns = [
  {
    title: '序号',
    width: 53,
    dataIndex: 'index',
    customRender: ({ index }) => index + 1,
    fixed: 'left'
  },
  {
    title: '商品信息',
    width: 175,
    slots: { customRender: 'goods_info' },
    fixed: 'left'
  },
  {
    dataIndex: 'Url',
    align: 'left',
    slots: { title:'top_url', customRender: 'url' },
    width: 110,
  },
  {
    title: '商品来源',
    slots: { customRender: 'type_str' },
    width: 63,
  },
  {
    title: 'SPU编号',
    dataIndex: 'GoodsId',
    slots: { customRender: 'goods_id' },
    width: 115,
  },
  {
    title: '铺货状态',
    dataIndex: 'StatusStr',
    slots: { customRender: 'status_str' },
    width: 83,
  },
  {
    title: '铺货失败原因',
    dataIndex: 'FallReason',
    slots: { customRender: 'fail_reason' },
    width: 140,
    align: 'left'
  },
  {
    title: '创建时间',
    dataIndex: 'CreateTime',
    sorter: (a, b) => {
      const aTime = new Date(a.CreateTime).getTime()
      const bTime = new Date(b.CreateTime).getTime()
      return aTime - bTime
    },
    width: 77,
  },
  {
    title: '完成时间',
    dataIndex: 'FinishTime',
    sorter: (a, b) => {
      const aTime = new Date(a.FinishTime || 0).getTime()
      const bTime = new Date(b.FinishTime || 0).getTime()
      return aTime - bTime
    },
    width: 77,
  },
  {
    title: '操作',
    width: 130,
    slots: { customRender: 'operate' },
    fixed: 'right'
  }
]

export default {
  columns
}